// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__kn3tZ","search":"Settings_search__1ZaNG","filter":"Settings_filter__1uBby"};